var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"music-card-list"},_vm._l((_vm.tracks),function(track){return _c('MusicCard',{key:track.id,attrs:{"track":track}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }